<template>
	<div class="container">
		<div class="content">
			<div class="banner">
				<img :src="detailModel.bannerFileUrl" />
			</div>
			<div class="active-time" v-if="isActiveStatus">
				<div class="active-time-cnt">
					<div class="active-time-l">
						<img src="@/assets/time_icon.png" />
						<span>活动报名还有：</span>
					</div>
					<div class="active-time-r">
						<span class="count-down">{{day}}</span>
						<span class="count-item">天</span>
						<span class="count-down">{{hour}}</span>
						<span class="count-item">时</span>
						<span class="count-down">{{minute}}</span>
						<span class="count-item">分</span>
						<span class="count-down">{{second}}</span>
						<span class="count-item">秒</span>
					</div>
				</div>
			</div>
			<div class="enrollment">
				<div class="enrollment-l">
					<span class=""></span>已报名{{joinCount}}人
				</div>
				<div class="enrollment-r">
					<img src="../../assets/default_head.png" />
					<img src="../../assets/default_head.png" />
					<img v-for="item in joinList" :src="item.headPic" />
				</div>
			</div>
			<div class="company">
				<span>发起方：</span>
				<span>{{detailModel.startCompayName}}</span>
			</div>
			<div class="detail-wrap" v-html="detailModel.content">

			</div>
			<div class="video-wrap" v-if="detailModel.videoFileUrl">
				<video controls :src="detailModel.videoFileUrl" style="">
					您的浏览器不支持 video 标签。
				</video>
			</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import {
		post,
		ajaxParam
	} from '@/units/request.js'
	export default {
		name: 'activityDetail',
		components: {},
		data() {
			return {
				id: '',
				detailModel: {},
				activityList: [],
				pageNum: 1,
				pageSize: 10,
				total: 0,
				day: '00',
				minute: '00',
				second: '00',
				hour: '00',
				isActiveStatus: false,
				joinList: {},
				joinCount: 0
			}
		},
		created() {
			this.id = this.$route.params.id
			this.getDetailData()
		},
		methods: {
			//获取活动详情
			async getDetailData() {
				let param = {}
				ajaxParam(param)
				const res = await post('v1/vacation/' + this.id, qs.stringify(param))
				if (res.data.code == 200) {
					this.detailModel = res.data.entity
					let newTime = Date.parse(new Date())
					let endTime = res.data.entity.recruitEndTime
					if (endTime > newTime) {
						this.getCountDown(endTime)
						this.isActiveStatus = true
					}
					this.joinList = res.data.joinList
					this.joinCount = res.data.joinCount
					document.title = res.data.entity.vacationName
				} else {
					this.$message.error(res.data.msg)
				}
			},
			getCountDown(endTime) {
				var nowtim = Date.parse(new Date())
				var count = (endTime - Date.parse(new Date()))
				if (count <= 0) {
					return
				}
				var intervalId = setInterval(() => {
					var t = (endTime - Date.parse(new Date()))
					if (t <= 0) {
						this.day = '00'
						this.hour = '00'
						this.minute = '00'
						this.second = '00'
						clearInterval(intervalId)
						return
					}
					var day = Math.floor(t / 1000 / 3600 / 24)
					var hour = Math.floor(t / 1000 / 60 / 60 % 24);
					var minute = Math.floor(t / 1000 / 60 % 60);
					var second = Math.floor(t / 1000 % 60);

					if (hour < 10) {
						hour = "0" + hour;
					}
					if (minute < 10) {
						minute = "0" + minute;
					}
					if (second < 10) {
						second = "0" + second;
					}
					this.day = day
					this.hour = hour
					this.minute = minute
					this.second = second
				}, 1000)

			}
		}
	}
</script>

<style scoped lang="less">
	.banner {
		img {
			width: 100%;
			height: 300px;
		}
	}

	/*倒计时*/
	.active-time {
		height: 34px;
		margin: 10px 0 0;
		padding: 0 10px;
		background: #f55;
		border-radius: 5px;
		position: relative;
	}

	.active-time-cnt {
		position: absolute;
		left: 20px;
		right: 20px;
		top: 0;
		bottom: 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 26px;
		color: #fff
	}

	.active-time-l,
	.active-time-r {
		display: flex;
		align-items: center;
	}

	.active-time-l img {
		width: 21px;
		height: 21px;
		margin-right: 7px
	}

	.active-time-l text {
		font: 18px;
	}

	.active-time-r {}

	.count-down {
		width: 22px;
		height: 22px;
		background: #000000;
		border-radius: 3px;
		font-size: 12px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.count-item {
		padding: 0 3px
	}

	.enrollment {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px;
		font-size: 14px;
		border-bottom: 1px solid #f3f3f3;
	}

	.enrollment-l .iconfont {
		margin-right: 5px;
		color: #666
	}

	.enrollment-r {
		display: flex;
	}

	.enrollment-r img {
		width: 30px;
		height: 30px;
		border-radius: 50%;
		margin-left: 10px
	}
	.company{
		margin-top: 10px;
		font-size: 14px;
		font-weight: bold;
	}
</style>
